import {
  SET_LOGGED_IN_STATE,
  SET_SESSION_TIMEOUT
} from "../../actions/account/accountActions";
import {
  SET_DEEP_LINKING_URL,
  SET_MEMBER_DETAIL_UPDATED
} from "../../actions/policy/policyActions";

const initialState = {
  isLoggedIn: false,
  deepLinkingUrl: null,
  memberDetailUpdated: null
};

export default function accountReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOGGED_IN_STATE:
      return {
        ...state,
        isLoggedIn: action.payload
      };
    case SET_SESSION_TIMEOUT:
      return {
        ...state,
        isTimedOut: action.payload
      };
    case SET_DEEP_LINKING_URL:
      return {
        ...state,
        deepLinkingUrl: action.payload
      };
    case SET_MEMBER_DETAIL_UPDATED:
      return {
        ...state,
        memberDetailUpdated: action.payload
      };
    default:
      return state;
  }
}
